// This icon file is generated automatically.
var PFallOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.47 11.56l-.38-3.11a.13.13 0 00-.21-.07l-.93.92-4.24-4.23a.25.25 0 00-.35 0L5.77 6.66 1.45 2.33a.13.13 0 00-.18 0l-.7.7a.13.13 0 000 .19l5.02 5.03c.1.1.26.1.36 0l1.59-1.6 3.53 3.54-.93.92c-.07.08-.03.2.08.22l3.11.37c.08.01.15-.06.14-.14z", "fill-rule": "nonzero" } }] }, "name": "p-fall", "theme": "outlined" };
export default PFallOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFallOutlined.js
// module id = 3370
// module chunks = 0